module.exports = __webpack_public_path__ + "static/media/logos_166x50_WSP.cfb38b23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_166x50_WSP.jpg
// module id = 231
// module chunks = 0